//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import metaBlob from '~~/data/meta-pages.json'

function getGaCustomerId() {
  let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)')
  const raw = match ? decodeURIComponent(match[1]) : null
  if (raw) {
    match = raw.match(/(\d+\.\d+)$/)
  }
  const gacid = match ? match[1] : null
  if (gacid) {
    return gacid
  }
}

export default {
  computed: {
    ...mapGetters('user', ['customerId', 'isGuest', 'isSubscriber']),

    test16() {
      return this.$store.getters['ui/getTestById'](16)
    }
  },

  watch: {
    $route() {
      if (document.activeElement) {
        document.activeElement.blur()
      }
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const l = document.location
      this.$gtm.push({
        customerStatus: this.isSubscriber ? 'Customer' : 'Non-Customer',
        originalLocation:
          l.protocol + '//' + l.hostname + l.pathname + l.search,
        userID: this.customerId || getGaCustomerId()
      })

      if (this.customerId) {
        this.$gtm.push({
          segment: this.$store.state.user.details.segment
        })
      }
    }
  },

  head() {
    const metadata = metaBlob.find(tag => tag.url === this.$route.path)

    const head = {
      bodyAttrs: {
        class: [`page-${this.$route.name}`]
      },
      title: metadata?.title,
      // Filters out all non-metadata and maps remaining to hid objects
      meta: metadata
        ? Object.keys(metadata)
            .filter(key => !['url', 'title'].includes(key) && metadata[key])
            .map(key => ({ hid: key, name: key, content: metadata[key] }))
        : []
    }

    return head
  }
}
